import { z } from 'zod';

import { createEventBus } from './utils/createEventBus';
import { singleton } from './utils/singleton';

export const LoginEventSchema = z.object({
  AccessToken: z.string(),
  IdToken: z.string(),
  redirectTo: z.string().optional(),
});

export const LogoutEventSchema = z.object({
  success: z.boolean(),
});

export const PostHogCaptureEventSchema = z.object({
  event: z.string(),
  properties: z.record(z.any()).optional(),
});

export const PostHogIdentifyEventSchema = z.object({
  distinctId: z.string(),
  properties: z.record(z.any()).optional(),
});

export const PostHogResetEventSchema = z.object({
  resetDeviceId: z.boolean().optional(),
});

export const OpenTopUpModalEventSchema = z.object({});

export const SavingsPointsLoadedEventSchema = z.object({});

// TT-137: the sole channel the Vue complete-profile page uses to hand its
// just-saved values to the host. Carries birthdate + phone_number so the host
// can clear the completion gate optimistically (no token refresh, no re-login).
export const ProfileCompletedEventSchema = z.object({
  birthdate: z.string(),
  phone_number: z.string(),
  redirectTo: z.string().optional(),
});

const eventConfig = {
  'mife:login': LoginEventSchema,
  'mife:logout': LogoutEventSchema,
  'posthog:capture': PostHogCaptureEventSchema,
  'posthog:identify': PostHogIdentifyEventSchema,
  'posthog:reset': PostHogResetEventSchema,
  'mife:open-top-up-modal': OpenTopUpModalEventSchema,
  'mife:savings-points-loaded': SavingsPointsLoadedEventSchema,
  'mife:profile-completed': ProfileCompletedEventSchema,
};

export const initEventBus = () => singleton('eventBus', () => createEventBus(eventConfig));
